import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { appServicesCatalog } from '../data/appServicesCatalog';
import RoiCalculator from './RoiCalculator';
import '../styles/homeCompanyCards.css';
import mobileAppIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 10_44_47 PM.png';
import productsShippedIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 10_51_49 PM.png';
import mvpDevelopmentIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 10_52_18 PM.png';
import arDevelopmentIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 10_55_21 PM.png';
import gameDevelopmentIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 10_57_22 PM.png';
import vrDevelopmentIcon from '../assets/home-roi-icons/ChatGPT Image Aug 19, 2026, 11_05_27 PM.png';
import productsShippedStatIcon from '../assets/home-services-icons/ChatGPT Image Aug 20, 2026, 01_00_19 AM.png';
import industriesServedStatIcon from '../assets/home-services-icons/ChatGPT Image Aug 20, 2026, 01_02_05 AM.png';
import yearsExperienceStatIcon from '../assets/home-services-icons/ChatGPT Image Aug 20, 2026, 01_06_11 AM.png';
import yearsBuildingCardBackground from '../assets/home-services-mvp-development.png';
import mvpPhonesCardImage from '../assets/home-services-mvp-phones-clean.png';
import productsShippedBackground from '../assets/home-company/products-shipped-background.png';
import industriesBuiltBackground from '../assets/home-company/industries-built-background.png';
import partnerOpenAiLogo from '../assets/home-company/partner-openai.png';
import partnerAwsLogo from '../assets/home-company/partner-aws.png';
import partnerStripeLogo from '../assets/home-company/partner-stripe.png';

const baseUrl = 'https://geeksroot.com';

const asset = (path) => `${baseUrl}/images/${path}`;
const localAsset = (path) => `${process.env.PUBLIC_URL}/images/${path}`;
// eslint-disable-next-line no-unused-vars
const serviceSections = [
  {
    id: 'graphics',
    route: '/services/graphics-design',
    tone: 'light',
    kicker: 'graphics',
    title: 'Designing',
    text:
      "Our graphic design services provide creative and impactful visual solutions to meet our clients' branding and communication needs.",
    bg: 'letsdrivebg.jpg',
    center: 'mainafter.png',
    links: ['branding', 'logo design', 'illustration', 'billboard', 'printing stuff', 'brochure'],
  },
  {
    id: 'web',
    route: '/services/web-development',
    tone: 'dark',
    kicker: 'web',
    title: 'Development',
    text:
      'Our web development services provide innovative and user-friendly website solutions to help our clients achieve their digital goals.',
    letters: ['w', 'e', 'b'],
    center: 'javasq.png',
    links: ['CMS development', 'e-commerce development', 'custom web application'],
  },
  {
    id: 'app',
    route: '/services/mobile-application',
    tone: 'dark',
    kicker: 'app',
    title: 'Development',
    text:
      'Provide innovative and user-friendly app solutions for iOS and Android platforms, helping our clients reach their target audience and achieve their digital goals.',
    letters: ['i', 'o', 's'],
    center: 'seoupper.png',
    links: ['Progressive Web Apps (PWA)', 'mobile app'],
  },
];

const reviewLogos = [
  ['clutch.svg', 'Clutch', '4.9', 'gold'],
  ['goodfirms', 'GoodFirms', '5.0', 'gold'],
  ['bark_elite_pro.svg', 'Bark', '5.0', 'gold'],
  ['awwwards', 'Awwwards', '4.5', 'gold'],
  ['trustpilot-cropped.svg', 'Trustpilot', '4.5', 'gold'],
];

function LowerSections() {
  return (
    <div className="lower-sections">
      <ImaginationSection />
      <HomeDiveSection />
      <HomeServicesSection />
      <RoiCalculator />
    </div>
  );
}

function HomeDiveSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.28 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`geeks-dive-section ${visible ? 'is-visible' : ''}`}
      aria-labelledby="home-dive-title"
    >
      <div className="home-dive-art-wrap" aria-hidden="true">
        <img
          className="home-dive-art"
          src={localAsset('home-dive/home-dive-wordmark-transparent.png')}
          alt=""
          width="550"
          height="788"
          loading="lazy"
          decoding="async"
        />
        <span className="home-dive-dot" />
      </div>
      <div className="home-dive-copy">
        <h2 id="home-dive-title">letsDIVE</h2>
        <p>
          As a consultancy and creative agency specialized in design and cultural projects with a
          focus on crafts, heritage, and innovation.
        </p>
      </div>
    </section>
  );
}

function ImaginationSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.38 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`lower-section app-company-section ${visible ? 'is-visible' : ''}`}
      aria-labelledby="app-company-title"
    >
      <div className="container2 app-company-layout">
        <div className="app-company-copy">
          <div className="app-company-kicker">Built for what&apos;s next.</div>
          <h2 id="app-company-title">We Build <span>Products</span> People Depend On</h2>
          <p>
            Strategy, design and engineering working as one&mdash;from the first idea to the product
            people actually use.
          </p>
          <Link className="app-company-cta" to="/connect">
            <span>Discuss Your Project</span>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </Link>
          <div className="company-partners">
            <p className="company-partners-label">Powered by the technologies<br />behind modern products</p>
            <div className="company-awards" aria-label="Technology platforms we work with">
              <AwardBadge variant="openai" />
              <AwardBadge variant="aws" />
              <AwardBadge variant="stripe" />
            </div>
          </div>
        </div>

        <div className="company-metrics company-metrics-editorial" aria-label="Appivorous delivery results">
          <EditorialMetric value="250+" label="Products Delivered" description={<>From first build to<br />real-world scale.</>} icon="mark" featured background={productsShippedBackground} />
          <EditorialMetric value="15+" label="Industries built for" description={<>Different industries.<br />Different problems.<br />The same engineering<br />discipline.</>} icon="building" background={industriesBuiltBackground} />
          <EditorialMetric value="12+" label="Years building" description={<>Experience earned<br />by solving real<br />product challenges.</>} icon="clock" background={yearsBuildingCardBackground} />
        </div>
      </div>
    </section>
  );
}

function EditorialMetric({ value, label, description, icon, featured = false, background }) {
  const icons = {
    mark: <svg viewBox="0 0 64 64" aria-hidden="true"><path d="M11 50 32 12l21 38M20 50l12-22 12 22" /></svg>,
    building: <svg viewBox="0 0 64 64" aria-hidden="true"><path d="M7 57h50M14 57V35h12v22M26 57V15h22v42M48 57V32h10v25M32 15V9h10v6M37 9V3M19 41h3m-3 7h3m10-26h4m6 0h2m-12 9h4m6 0h2m-12 9h4m6 0h2m-10 17v-7h8v7" /></svg>,
    clock: <svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="23" /><path d="M32 17v16l11 7" /></svg>,
  };
  const artwork = {
    mark: '/images/home-company/products-shipped-art.svg',
    building: '/images/home-company/industries-art.svg',
    clock: '/images/home-company/years-art.svg',
  };

  return (
    <article
      className={`editorial-result-card editorial-result-${icon} ${featured ? 'editorial-result-featured' : ''} ${background ? 'editorial-result-has-background' : ''}`}
      style={background ? {
        backgroundImage: `url(${background})`,
        backgroundSize: icon === 'clock' ? 'calc(100% + 32px) calc(100% + 32px)' : 'cover',
        backgroundColor: '#06101f',
      } : undefined}
    >
      <span className="editorial-result-icon">{icons[icon]}</span>
      <span className="editorial-result-label">{label}</span>
      <strong>{value}</strong>
      <i aria-hidden="true" />
      <p>{description}</p>
      <img className="editorial-result-art" src={`${process.env.PUBLIC_URL}${artwork[icon]}`} alt="" aria-hidden="true" />
    </article>
  );
}

function AwardBadge({ variant }) {
  const badges = {
    openai: { src: partnerOpenAiLogo, alt: 'OpenAI' },
    aws: { src: partnerAwsLogo, alt: 'Amazon Web Services' },
    stripe: { src: partnerStripeLogo, alt: 'Stripe' },
  };
  const badge = badges[variant];

  return (
    <div className={`award-badge award-badge-${variant}`}>
      <img src={badge.src} alt={badge.alt} width="128" />
    </div>
  );
}

function HomeServicesSection() {
  const serviceCards = [
    { ...appServicesCatalog[0], icon: mobileAppIcon, image: '/images/home-services/01-mobile-app.png' },
    { ...appServicesCatalog[1], icon: gameDevelopmentIcon, image: '/images/home-services/05-game-development.png' },
    { ...appServicesCatalog[2], icon: mvpDevelopmentIcon, image: mvpPhonesCardImage, importedImage: true },
    { ...appServicesCatalog[3], icon: arDevelopmentIcon, image: '/images/home-services/04-ar-development.png' },
    { ...appServicesCatalog[4], icon: vrDevelopmentIcon, image: '/images/home-services/06-vr-development.png' },
    { ...appServicesCatalog[5], icon: productsShippedIcon, image: '/images/home-services/03-app-maintenance.png' },
  ];

  return (
    <section className="home-services-catalog" id="services">
      <header className="home-services-heading">
        <div className="home-services-intro">
          <small>Mobile application development</small>
          <h2>Your App Idea Deserves<br />More Than Just <span>Development.</span></h2>
          <p>We turn ambitious ideas into intuitive, scalable applications—from product strategy and MVP development to launch, growth, and continuous evolution.</p>
          <Link className="home-services-cta" to="/connect">Build Your App <span>→</span></Link>
        </div>
        <div className="home-services-stats" aria-label="Our experience">
          <div><span className="home-stat-icon"><img src={productsShippedStatIcon} alt="" /></span><b>250+</b><strong>Products Delivered</strong><p>Built. Launched. Trusted<br />by real users.</p></div>
          <div><span className="home-stat-icon"><img src={industriesServedStatIcon} alt="" /></span><b>15+</b><strong>Industries Served</strong><p>Different domains.<br />Real-world impact.</p></div>
          <div><span className="home-stat-icon"><img src={yearsExperienceStatIcon} alt="" /></span><b>12+</b><strong>Years of Experience</strong><p>Expertise that evolves<br />with technology.</p></div>
        </div>
      </header>
      <div className="home-services-list">
        {serviceCards.map((service, index) => (
          <Link to={service.path} key={service.slug} className="home-service-row">
            <div className="home-service-visual">
              <span className="home-service-index">{String(index + 1).padStart(2, '0')}</span>
              <span className="home-service-icon"><img src={service.icon} alt="" /></span>
              <img src={service.importedImage ? service.image : `${process.env.PUBLIC_URL}${service.image}`} alt="" loading="lazy" />
            </div>
            <span className="home-service-copy">
              <strong>{service.title}</strong>
              <p>{service.description}</p>
            </span>
            <span className="home-service-arrow" aria-hidden="true">↗</span>
          </Link>
        ))}
      </div>
    </section>
  );
}

// eslint-disable-next-line no-unused-vars
function ProcessIcon({ type }) {
  if (type === 'discover') {
    return <svg viewBox="0 0 48 48"><path d="M9 7h23v28H9zM14 13h13M14 19h9M29 29l10 10M35 27a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" /></svg>;
  }
  if (type === 'design') {
    return <svg viewBox="0 0 48 48"><path d="m10 36 8-23 20 20-23 7-5-4Zm8-23 6-6 17 17-6 6M15 33l7-7M28 11l9 9" /></svg>;
  }
  if (type === 'develop') {
    return <svg viewBox="0 0 48 48"><rect x="6" y="8" width="36" height="31" rx="3" /><path d="M6 16h36M12 12h.1M17 12h.1M22 12h.1m-3 13-5 4 5 4m10-8 5 4-5 4m-3-11-4 14" /></svg>;
  }
  return <svg viewBox="0 0 48 48"><path d="M7 14h22M7 24h34M7 34h27" /><circle cx="33" cy="14" r="4" /><circle cx="13" cy="24" r="4" /><circle cx="38" cy="34" r="4" /><path d="m36 41 3 3 6-7" /></svg>;
}

// Kept as a reusable legacy composition; the expanded version now lives at /our-process.
// eslint-disable-next-line no-unused-vars
function ProcessSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const steps = [
    { number: '01', type: 'discover', title: 'Define', text: 'We unpack your goals, users, challenges, and opportunities to define a clear direction before the work begins.' },
    { number: '02', type: 'design', title: 'Design', text: 'Ideas become thoughtful flows and polished interfaces, shaped through prototypes and focused collaboration.' },
    { number: '03', type: 'develop', title: 'Develop', text: 'Our engineers turn the approved experience into a fast, stable, and scalable digital product.' },
    { number: '04', type: 'deliver', title: 'Deliver', text: 'We test, refine, launch, and stay close after release so your product keeps moving forward.' },
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, { threshold: 0.22 });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`lower-section home-process-section ${visible ? 'is-visible' : ''}`}>
      <div className="process-heading">
        <small>How we work</small>
        <h2>Our <span>Process</span></h2>
        <p>From the first conversation to launch, every step is clear, collaborative, and built around momentum.</p>
      </div>
      <div className="process-map">
        <svg className="process-connector" viewBox="0 0 1000 220" preserveAspectRatio="none" aria-hidden="true">
          <polyline points="125,42 375,176 625,42 875,176" />
        </svg>
        {steps.map((step, index) => (
          <article className="process-step" key={step.number} style={{ '--step-index': index }}>
            <span className="process-number">{step.number}</span>
            <div className="process-icon"><ProcessIcon type={step.type} /></div>
            <div className="process-copy">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

// eslint-disable-next-line no-unused-vars
function MissionSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const missionAxis = ['Research', 'Design', 'Build', 'Scale'];
  const missionSteps = [
    { index: '01', title: 'Product Clarity', detail: 'Sharper direction before a single pixel or line of code moves.' },
    { index: '02', title: 'Premium Interface', detail: 'Polished screens that feel intentional, clean, and easy to trust.' },
    { index: '03', title: 'Engineering Flow', detail: 'Modern builds shaped for speed, stability, and long-term growth.' },
    { index: '04', title: 'Launch Momentum', detail: 'Refinement, rollout, and iteration after the first release.' },
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.38 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`lower-section dark-section mission-section exact-mission ${visible ? 'is-visible' : ''}`}
    >
      <div className="mission-premium-heading">
        <small>Our Mission</small>
        <h2>Digital products with appetite, polish, and precision.</h2>
        <p>We bring product thinking, interface craft, and engineering discipline into one focused delivery system.</p>
      </div>
      <div className="container2 exact-mission-grid">
        <div className="mission-panel">
          <div className="mask1 MaskJs1" />
          <div className="maskTextLeft">
            <div className="maskTextLeftInner">
              <div className="Peraslider FaceTextJS">
                <p>We are hungry for sharper ideas and better digital products.</p>
                <p>
                  Every project becomes a focused system: strategy, design, engineering, and launch
                  momentum working together so the result feels clear, durable, and ready for what's next.
                </p>
              </div>
              <div className="mission-proof-row" aria-label="Mission strengths">
                <span>Strategy</span><span>Design</span><span>Delivery</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mission-panel">
          <div className="mask2 MaskJs2" />
          <div className="centerline">
            <div className="text3dleft leyer4JS"><img src={asset('3.png')} alt="" className="lognimg3" /></div>
            <div className="bothcenterline" />
            <div className="mission-axis-card" aria-label="Mission workflow">
              {missionAxis.map((item) => <span key={item}>{item}</span>)}
            </div>
            <div className="text3dright leyer3JS">
              <img src={localAsset('section-4-purple.png')} alt="" className="lognimg4" />
              <span className="centercircle2 theme-circle" aria-hidden="true" />
            </div>
          </div>
        </div>
        <div className="mission-panel">
          <div className="mask3 MaskJs3" />
          <div className="worklogo">
            <div className="demo NftHeading NftHeadingJs">
              {missionSteps.map((step) => (
                <div key={step.index} className="mission-step-card">
                  <span className="mission-step-index">{step.index}</span>
                  <span className="mission-step-title">{step.title}</span>
                  <small>{step.detail}</small>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// eslint-disable-next-line no-unused-vars
function ServiceSection({ section }) {
  const isDark = section.tone === 'dark';

  if (isDark) {
    return <TechServiceSection section={section} />;
  }

  return (
    <section
      id={section.id}
      className="lower-section service-section dive-section graphics-section"
      style={{ '--section-bg': `url(${asset(section.bg)})`, '--center-art': `url(${asset(section.center)})` }}
    >
<div className="container2 split-service-grid">
        <div className="service-copy gradient-title graphic-copy">
          <small>{section.kicker}</small>
          <span>{section.title}</span>
          <p>{section.text}</p>
          <Link className="service-page-inline-link" to={section.route}>Explore Service</Link>
        </div>
        <LinkList links={section.links} route={section.route} />
      </div>
    </section>
  );
}

// eslint-disable-next-line no-unused-vars
function TechServiceSection({ section }) {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const isApp = section.id === 'app';

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const reveal = () => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.72 && rect.bottom > window.innerHeight * 0.2) {
        setVisible(true);
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.12, rootMargin: '0px 0px -18% 0px' }
    );

    reveal();
    observer.observe(element);
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', reveal);
      window.removeEventListener('resize', reveal);
    };
  }, []);

  return (
    <section
      id={section.id}
      ref={sectionRef}
      className={`lower-section dark-section exact-tech-section exact-${section.id}-section ${visible ? 'is-visible' : ''}`}
    >
      <div className={`backSeo ${isApp ? 'backIosJs IOS' : 'backSeoJs'}`}>
        {section.letters.map((letter) => (
          <small key={letter}>{letter}</small>
        ))}
      </div>
      <div className={`container2 webJavaText ${isApp ? 'webJavaText2' : ''}`}>
        <div className="exact-tech-grid">
          <div className="tech-left-col">
            <div className="letsdivemain">
              <div className={`WebText ${isApp ? 'WebTextJs2' : 'WebTextJs'}`}>
                <h1><small>{section.kicker}</small></h1>
                <h2><span>{section.title}</span></h2>
                <p>{section.text}</p>
                <Link className="service-page-inline-link tech-explore-link" to={section.route}>Explore Service</Link>
                <div className="clearfix" />
              </div>
            </div>
          </div>
          <div className="tech-mid-col" aria-hidden="true">
            <div className={`tech-showcase ${isApp ? 'tech-showcase-app' : 'tech-showcase-web'}`}>
              <span className="tech-showcase-frame" />
              <span className="tech-showcase-line" />
              <span className="tech-showcase-line" />
              <span className="tech-showcase-chip" />
            </div>
          </div>
          <div className="tech-right-col">
            <div className={`centerLinks centerLinks2 ${isApp ? 'WeblistJs2' : 'WeblistJs'}`}>
              <ul>
                {section.links.map((link) => (
                  <li key={link}>
                    <Link to={section.route}>{link}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// eslint-disable-next-line no-unused-vars
function AnimationSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const reveal = () => {
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95 && rect.bottom > 0) {
        setVisible(true);
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.01, rootMargin: '0px 0px -4% 0px' }
    );

    reveal();
    observer.observe(section);
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', reveal);
      window.removeEventListener('resize', reveal);
    };
  }, []);

  return (
    <section
      id="animation"
      ref={sectionRef}
      className={`lower-section animation-section dive-section ${visible ? 'is-visible' : ''}`}
      style={{ '--section-bg': `url(${asset('3dbg.jpg')})`, '--center-art': `url(${asset('mainafter.png')})` }}
    >
      <div className="jump-vector">
        <img src={asset('moveVectr.png')} alt="JumpVector" />
      </div>
      <div className="container2 split-service-grid">
        <div className="service-copy gradient-title two-d-copy">
          <div className="two-d-title">
            <small>2D / </small>
            <span>3D</span>
          </div>
          <p>
            Provide high-quality and visually appealing designs an animations, helping our clients
            bring their creative visions to life in various industries including gaming,
            entertainment, and architecture.
          </p>
          <Link className="service-page-inline-link" to="/services/animation">Explore Service</Link>
        </div>
        <LinkList
          links={['2D - 3D art', 'motion gfx', 'concept art', 'digital art', 'game', 'explainer video']}
          route="/services/animation"
        />
      </div>
    </section>
  );
}

export function FinalSection() {
  return (
    <section className="final-section" aria-labelledby="client-trust-title">
      <div className="container2 final-inner">
        <header className="trust-section-heading">
          <small>Trusted worldwide</small>
          <h2 id="client-trust-title">Built on results. <span>Backed by clients.</span></h2>
          <p>Independent platforms recognize the quality, reliability, and care behind every product we deliver.</p>
        </header>
        <div className="reviews-footer trust-dashboard">
          <div className="trust-stats" aria-label="Company performance statistics">
            <TrustStat icon="people" value="1200+" label="Happy Clients" />
            <TrustStat icon="star" value="98%" label="Client Satisfaction" />
            <TrustStat icon="globe" value="50+" label="Countries Served" />
          </div>
          <div className="review-logos">
            {reviewLogos.map(([image, alt, rating, tone]) => (
              <a className={`review-card review-card-${tone}`} href="https://appivorous.com" target="_blank" rel="noreferrer" key={alt} aria-label={`View Appivorous on ${alt}`}>
                {image === 'awwwards' ? (
                  <span className="awwwards-logo" aria-label="Awwwards">AWW<span>W</span>ARDS<sup>®</sup></span>
                ) : image === 'goodfirms' ? (
                  <span className="goodfirms-logo" aria-label="GoodFirms"><i>G</i> GoodFirms</span>
                ) : (
                  <img src={asset(image)} alt={alt} />
                )}
                <span className="review-stars" aria-hidden="true">★★★★★</span>
                <small>{rating}</small>
              </a>
            ))}
          </div>
        </div>
        <div className="combined-rating" aria-label="Rated 4.9 out of 5 across trusted platforms">
          <span aria-hidden="true">★★★★★</span><i /><strong>Rated 4.9/5<small>Across Trusted Platforms</small></strong>
        </div>
      </div>
    </section>
  );
}

function TrustStat({ icon, value, label }) {
  const statRef = useRef(null);
  const target = Number.parseInt(value, 10);
  const suffix = value.replace(String(target), '');
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const stat = statRef.current;
    if (!stat) return undefined;

    let animationFrame;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setDisplayValue(target);
        return;
      }

      const duration = 1800;
      const startedAt = performance.now();
      const animateCount = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = 1 - ((1 - progress) ** 3);
        setDisplayValue(Math.min(target, Math.max(0, Math.round(target * eased))));
        if (progress < 1) animationFrame = requestAnimationFrame(animateCount);
      };
      animationFrame = requestAnimationFrame(animateCount);
    }, { threshold: 0.35 });

    observer.observe(stat);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(animationFrame);
    };
  }, [target]);

  const paths = {
    people: <><circle cx="9" cy="9" r="3"/><circle cx="18" cy="10" r="2.5"/><path d="M3.5 21v-2.5A5.5 5.5 0 0 1 9 13h1a5.5 5.5 0 0 1 5.5 5.5V21M16 14.5a4.5 4.5 0 0 1 5 4.5v2"/></>,
    star: <path d="m12 2.5 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9L12 2.5Z"/>,
    globe: <><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.5 3.7 5.5 3.7 9S14.5 18.5 12 21c-2.5-2.5-3.7-5.5-3.7-9S9.5 5.5 12 3Z"/></>,
  };
  return <div className="trust-stat" ref={statRef}><span><svg viewBox="0 0 24 24" aria-hidden="true">{paths[icon]}</svg></span><div><strong>{displayValue}{suffix}</strong><small>{label}</small></div></div>;
}

function LinkList({ links, dark = false, route = '/' }) {
  return (
    <nav className={`section-links ${dark ? 'light-links' : ''}`} aria-label="Section links">
      <ul>
        {links.map((link) => (
          <li key={link}>
            <Link to={route}>{link}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default LowerSections;
